import type { Router } from "vue-router";
import api from "../api";
import { appendHandoffCode, classifyReturn, takePendingReturn } from "../utils/loginReturn";

export type ReturnResult = "navigated" | "nothing" | "failed";

// Завершает отложенный возврат единой формы входа. Вызывать, когда
// пользователь аутентифицирован. take* атомарно забирает значение, поэтому
// параллельные вызовы (страница /login и watcher в App.vue) не выполнят
// возврат дважды. При сбое handoff значение НЕ возвращается в хранилище:
// иначе оно сработало бы при любой следующей загрузке страницы. Повтор =
// заново открыть /login?return=... .
export async function completePendingReturn(
  router: Router,
  navigate: (url: string) => void = (url) => window.location.replace(url)
): Promise<ReturnResult> {
  const raw = takePendingReturn();
  if (!raw) return "nothing";
  const target = classifyReturn(raw, window.location.origin);
  if (target.kind === "none") return "nothing";
  if (target.kind === "hard") {
    navigate(target.url);
    return "navigated";
  }
  if (target.kind === "internal") {
    await router.replace(target.path);
    return "navigated";
  }
  try {
    const res = await api.post("/auth/handoff", { return_url: target.url });
    navigate(appendHandoffCode(target.url, res.data.code));
    return "navigated";
  } catch {
    return "failed";
  }
}

// OAuth/verify-страницы после своего async-флоу уходят на /map, но к этому
// моменту watcher в App.vue мог уже завершить отложенный возврат и увести
// роутер дальше - не перебиваем его.
export async function replaceIfStillOn(router: Router, fromPath: string, to: string): Promise<void> {
  if (router.currentRoute.value.path === fromPath) await router.replace(to);
}
